const EnumConstants = {
    Active: 1,
    Completed: 6,
    InProgress: 7,
    Deleted: 5,
}
export default EnumConstants;